import { getField } from 'vuex-map-fields'

const account = state => state.account.data
const error = state => state.error
const isLoading = state => state.isLoading

const changePassword = state => state.changePassword.data
const errorChangePassword = state => state.errorChangePassword
const isLoadingChangePassword = state => state.isLoadingChangePassword

const updateAccount = state => state.updateAccount.data
const errorUpdateAccount = state => state.errorUpdateAccount.data
const isLoadingUpdateAccount = state => state.isLoadingUpdateAccount

const editAccount = state => state.editAccount
const errorEditAccount = state => state.errorEditAccount
const isLoadingEditAccount = state => state.isLoadingEditAccount

export default {
  getField,
  isLoading,
  account,
  error,

  changePassword,
  errorChangePassword,
  isLoadingChangePassword,

  updateAccount,
  errorUpdateAccount,
  isLoadingUpdateAccount,

  editAccount,
  errorEditAccount,
  isLoadingEditAccount
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/account/getters.js